import type { Group } from '@medplum/fhirtypes';
import { getGroupTemplateRef } from '@unify/fhir-model/resources/group';

export function initialsFromDisplayName(name: string): string {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
  return initials || 'G';
}

export function resolveGroupSessionHeader(
  group: Group | null | undefined,
  opts?: { fallbackDisplay?: string; templateDisplay?: string },
): {
  groupId: string | undefined;
  groupName: string;
  groupInitials: string;
  groupSubtitle: string | undefined;
} {
  const groupId = group?.id;
  const groupName =
    group?.name?.trim() ||
    opts?.fallbackDisplay?.trim() ||
    'Group session';
  const templateName =
    opts?.templateDisplay?.trim()
    || (group ? getGroupTemplateRef(group)?.display?.trim() : undefined);
  const groupSubtitle =
    templateName && templateName !== groupName ? templateName : undefined;

  return {
    groupId,
    groupName,
    groupInitials: initialsFromDisplayName(groupName),
    groupSubtitle,
  };
}
